import { useEffect, useState } from "react";
import {
  LocalParticipant,
  RemoteParticipant,
  ParticipantEvent,
} from "livekit-client";

export function useParticipantSpeaking(
  participant?: LocalParticipant | RemoteParticipant
) {
  const [isSpeaking, setIsSpeaking] = useState<boolean>(false);

  useEffect(() => {
    if (!participant) return;

    const handle = (speaking: boolean) => setIsSpeaking(speaking);

    setIsSpeaking(participant.isSpeaking);
    participant.on(ParticipantEvent.IsSpeakingChanged, handle);

    return () => {
      participant.off(ParticipantEvent.IsSpeakingChanged, handle);
    };
  }, [participant]);

  return isSpeaking;
}
